import { Box, Paper, Stack, Typography } from "@tm/components"
import { ArticleInfoType, PriceType } from "@tm/models"
import { useLocalization } from "@tm/localization"
import ArticleNumbers from "../ArticleNumbers"
import ArticleThumbnail from "../PartsTableCells/ArticleThumbnail"
import { BasketPart } from "../../../models"
import { ValueLabelStack } from "../../ValueLabelStack"
import { findPrice } from "../../../helpers"

type Props = {
    part: BasketPart
    hidePurchasePrice?: boolean
    showManufacturer?: boolean
    showSupplierArticleNumbers?: boolean
    showWholesalerArticleNumbers?: boolean
}

export function PartBasicInfo(props: Props) {
    const { part, showSupplierArticleNumbers, showManufacturer, showWholesalerArticleNumbers, hidePurchasePrice } = props
    const { translateText, formatCurrency } = useLocalization()
    const { partItem, erpInfoResponse } = part
    const { articleInformation, externalId } = partItem
    const { supplierName, description, articleNumber, productGroupName, wholesalerArticleNumber } = articleInformation

    const isOePart = articleInformation?.articleInfoType === ArticleInfoType.OeArticle
    const isTecDocPart = articleInformation?.articleInfoType === ArticleInfoType.TecdocArticle
    const erpPrices = erpInfoResponse?.prices ? Object.values(erpInfoResponse?.prices) : undefined
    const purchasePrice = findPrice(erpPrices, PriceType.Purchase)
    const retailPrice = findPrice(erpPrices, PriceType.Retail) ?? findPrice(erpPrices, PriceType.RecommendedRetail)

    return (
        <Paper>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" gap={3} flex={1} alignItems="center">
                    <ArticleThumbnail part={part} />
                    {showManufacturer && <Typography>{supplierName}</Typography>}
                    {(showSupplierArticleNumbers || showWholesalerArticleNumbers) && (
                        <ArticleNumbers
                            externalBasketItemId={externalId}
                            oeArticleNumber={showSupplierArticleNumbers && isOePart ? articleNumber : undefined}
                            supplierArticleNumber={showSupplierArticleNumbers && isTecDocPart ? articleNumber : undefined}
                            wholesalerArticleNumber={showWholesalerArticleNumbers ? wholesalerArticleNumber : undefined}
                        />
                    )}
                    <Typography textAlign="center" variant="body2">
                        {description || productGroupName}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={3}>
                    <ValueLabelStack label={translateText(89)} value="1" alignValueCenter />
                    <Box display="grid" gridTemplateColumns="auto auto" columnGap={1}>
                        {!hidePurchasePrice && (
                            <>
                                <Typography variant="body2">{translateText(55)}</Typography>
                                <Box textAlign="right">
                                    <Typography variant="body2">
                                        {purchasePrice
                                            ? formatCurrency(purchasePrice.value, purchasePrice.currencySymbol ?? purchasePrice.currencyCode_Iso_4217)
                                            : "-"}
                                    </Typography>
                                </Box>
                            </>
                        )}
                        <>
                            <Typography variant="body2">{translateText(1620)}</Typography>
                            <Box textAlign="right">
                                <Typography variant="body2">
                                    {retailPrice ? formatCurrency(retailPrice.value, retailPrice.currencySymbol ?? retailPrice.currencyCode_Iso_4217) : "-"}
                                </Typography>
                            </Box>
                        </>
                    </Box>
                </Stack>
            </Stack>
        </Paper>
    )
}
